"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
var react_1 = __importStar(require("react"));
var react_admin_1 = require("react-admin");
var RAStyles_1 = require("../common/ReactAdmin/RAStyles");
var styles_1 = require("@mui/material/styles");
var ThumbnailSmall_1 = __importDefault(require("./ThumbnailSmall"));
var useReactAdminDoubleClick_1 = __importDefault(require("@/Hooks/useReactAdminDoubleClick"));
var MeatballMenuField_1 = __importDefault(require("./MeatballMenuField"));
var react_i18next_1 = require("react-i18next");
var q_play_components_1 = require("@nordicscreen/q-play-components");
var q_play_core_1 = require("@nordicscreen/q-play-core");
var MediaPreviewModal_1 = __importDefault(require("./MediaPreviewModal"));
var CustomEmpty_1 = __importDefault(require("./CustomEmpty"));
var MediaDetailsDialog_1 = __importDefault(require("./MediaDetailsDialog"));
var react_dnd_1 = require("react-dnd");
var react_dnd_html5_backend_1 = require("react-dnd-html5-backend");
var CustomNoResults_1 = __importDefault(require("../common/ReactAdmin/CustomNoResults"));
var TypeField = function (_a) {
    var source = _a.source, label = _a.label, sortable = _a.sortable;
    var record = (0, react_admin_1.useRecordContext)();
    if (!record)
        return null;
    var t = (0, react_i18next_1.useTranslation)().t;
    var extension = record.file_name ? record.file_name.split(".").pop() : null;
    var type = extension && extension !== record.file_name ? extension :
        (record.mime_type ? record.mime_type.split("/").pop() : t("Folder"));
    var displayType = type;
    var title = null;
    if (type !== t("Folder") && type.length > 4) {
        displayType = "".concat(type.substring(0, 4), "...");
        title = type;
    }
    return (react_1.default.createElement("span", { className: "ns-font-family", style: { color: "var(--info-color)" }, title: title }, displayType));
};
var ThumbnailWithNameField = function (_a) {
    var permissions = _a.permissions, selectedFolderIds = _a.selectedFolderIds, selectedMediaIds = _a.selectedMediaIds, handleChangeFolderName = _a.handleChangeFolderName, label = _a.label, folderPermissions = _a.folderPermissions;
    var record = (0, react_admin_1.useRecordContext)();
    if (!record)
        return null;
    var isFolder = !record.mime_type;
    var isDragging = (0, react_dnd_1.useDrag)({
        type: isFolder ? "FOLDER" : "MEDIA",
        item: function () {
            var id = isFolder ? record.id : record.originalId;
            return { id: id, type: isFolder ? "FOLDER" : "MEDIA", selectedMediaIds: selectedMediaIds, selectedFolderIds: selectedFolderIds };
        },
        collect: function (monitor) { return ({
            isDragging: monitor.isDragging(),
        }); },
    })[0].isDragging;
    var _b = (0, react_dnd_1.useDrop)({
        accept: ["MEDIA", "FOLDER"],
        drop: function () {
            return { folderId: isFolder ? record.id : null };
        },
        collect: function (monitor) { return ({
            isOver: monitor.isOver(),
            canDrop: monitor.canDrop(),
        }); },
    }), _c = _b[0], isOver = _c.isOver, canDrop = _c.canDrop, drop = _b[1];
    return (react_1.default.createElement("div", { ref: isFolder ? drop : null, style: {
            display: "flex",
            alignItems: "center",
            opacity: isDragging ? 0.5 : 1,
            backgroundColor: isOver && canDrop && isFolder ? "#f5ffce61" : "transparent",
        } },
        react_1.default.createElement(ThumbnailSmall_1.default, { item: record, isFolder: isFolder, permissions: permissions, handleChangeFolderName: handleChangeFolderName, selectedFolderIds: selectedFolderIds, selectedMediaIds: selectedMediaIds, folderPermissions: folderPermissions })));
};
var CheckBoxAction = function (_a) {
    var items = _a.items, onCheckBoxTick = _a.onCheckBoxTick;
    var selectedIds = (0, react_admin_1.useListContext)().selectedIds;
    (0, react_1.useEffect)(function () {
        var selectedFolderIds = [];
        var selectedMediaIds = [];
        selectedIds.forEach(function (id) {
            var item = items.find(function (item) { return item.uuid === id || item.id === id; });
            if (item) {
                if (item.type === "FOLDER") {
                    selectedFolderIds.push(item.id);
                }
                else {
                    selectedMediaIds.push(item.id);
                }
            }
        });
        onCheckBoxTick(selectedFolderIds, selectedMediaIds);
    }, [selectedIds, items, onCheckBoxTick]);
    return null;
};
var MediaLibraryListView = function (_a) {
    var folders = _a.folders, media = _a.media, onDownloadMedia = _a.onDownloadMedia, onDeleteFolder = _a.onDeleteFolder, onDeleteMedia = _a.onDeleteMedia, selectedFolderIds = _a.selectedFolderIds, setSelectedFolderIds = _a.setSelectedFolderIds, selectedMediaIds = _a.selectedMediaIds, setSelectedMediaIds = _a.setSelectedMediaIds, fetchFolderContents = _a.fetchFolderContents, collectionName = _a.collectionName, mediaDoubleClickHandler = _a.mediaDoubleClickHandler, _b = _a.searchQuery, searchQuery = _b === void 0 ? "" : _b, handleChangeFolderName = _a.handleChangeFolderName, handleMoveMultipleFoldersToFolder = _a.handleMoveMultipleFoldersToFolder, handleMoveMultipleMediaToFolder = _a.handleMoveMultipleMediaToFolder, openFolderAccessModal = _a.openFolderAccessModal, permissions = _a.permissions, folderPermissions = _a.folderPermissions;
    var _c = (0, react_1.useState)(false), setCheckBoxIsActive = _c[1];
    var t = (0, react_i18next_1.useTranslation)().t;
    var resourceString = (0, react_admin_1.useResourceContext)();
    var _d = (0, react_admin_1.useRecordSelection)(resourceString), selectedIds = _d[0], _e = _d[1], select = _e.select, unselect = _e.unselect;
    var _f = (0, react_1.useState)(false), confirmationModalOpened = _f[0], setConfirmationModalOpened = _f[1];
    var _g = (0, react_1.useState)({ folders: [], media: [] }), itemsToDelete = _g[0], setItemsToDelete = _g[1];
    var logger = q_play_core_1.logManager.getLogger();
    var _h = (0, react_1.useState)(false), previewModalShown = _h[0], setPreviewModalShown = _h[1];
    var _j = (0, react_1.useState)(null), previewImageUrl = _j[0], setPreviewImageUrl = _j[1];
    var _k = (0, react_1.useState)(null), previewMediaType = _k[0], setPreviewMediaType = _k[1];
    var _l = (0, react_1.useState)(false), detailsDialogOpen = _l[0], setDetailsDialogOpen = _l[1];
    var _m = (0, react_1.useState)(null), selectedMediaDetails = _m[0], setSelectedMediaDetails = _m[1];
    var _o = (0, react_1.useState)(null), anchorEl = _o[0], setAnchorEl = _o[1];
    var items = (0, react_1.useMemo)(function () { return __spreadArray(__spreadArray([], folders.map(function (folder) { return (__assign(__assign({}, folder), { type: "FOLDER" })); }), true), media.map(function (mediaItem) { return (__assign(__assign({}, mediaItem), { id: mediaItem.uuid, originalId: mediaItem.id, type: "MEDIA" })); }), true); }, [folders, media]);
    var filteredItems = (0, react_1.useMemo)(function () { return items.filter(function (item) { return item.name.toLowerCase().includes(searchQuery.toLowerCase()); }); }, [items, searchQuery]);
    var onCheckBoxTickHandler = (0, react_1.useCallback)(function (selectedFolderIds, selectedMediaIds) {
        setSelectedFolderIds(function (prev) {
            var hasChanged = prev.length !== selectedFolderIds.length || prev.some(function (id) { return !selectedFolderIds.includes(id); });
            return hasChanged ? selectedFolderIds : prev;
        });
        var updatedMediaIds = selectedMediaIds.map(function (uuid) {
            var item = items.find(function (item) { return item.uuid === uuid; });
            if (item && "originalId" in item) {
                return item.originalId;
            }
            return uuid;
        });
        setSelectedMediaIds(function (prev) {
            var hasChanged = prev.length !== updatedMediaIds.length || prev.some(function (id) { return !updatedMediaIds.includes(id); });
            return hasChanged ? updatedMediaIds : prev;
        });
        var updatedSelectedIds = __spreadArray(__spreadArray([], selectedFolderIds, true), updatedMediaIds, true);
        setCheckBoxIsActive(updatedSelectedIds.length > 0);
    }, [items, setSelectedFolderIds, setSelectedMediaIds]);
    var togglePreviewModal = (0, react_1.useCallback)(function () {
        setPreviewModalShown(function (prev) { return !prev; });
    }, []);
    var viewMedia = (0, react_1.useCallback)(function (media) {
        setPreviewImageUrl(media.url);
        setPreviewMediaType(media.mime_type);
        togglePreviewModal();
    }, [togglePreviewModal]);
    var handleViewMedia = (0, react_1.useCallback)(function (e, media) {
        e.stopPropagation();
        viewMedia(media);
    }, [viewMedia]);
    var handleRowClick = (0, useReactAdminDoubleClick_1.default)({
        onSingleClick: function (record) {
            var recordId = record.uuid || record.id;
            if (selectedIds.includes(recordId)) {
                unselect([recordId]);
            }
            else {
                select(__spreadArray(__spreadArray([], selectedIds, true), [recordId], false));
            }
            return false;
        },
        onDoubleClick: function (record) {
            if (record.type === "FOLDER") {
                fetchFolderContents(record.id, record.name);
            }
            else if (record.type === "MEDIA") {
                mediaDoubleClickHandler(record.originalId);
                handleViewMedia(new MouseEvent("click"), record);
            }
            return false;
        },
    });
    var toggleConfirmationModal = function () {
        setConfirmationModalOpened(function (prevState) { return !prevState; });
    };
    var handleDeleteRequest = function (folders, media) {
        setItemsToDelete({ folders: folders, media: media });
        toggleConfirmationModal();
    };
    var handleConfirmDelete = function () { return __awaiter(void 0, void 0, void 0, function () {
        var error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    itemsToDelete.folders.forEach(function (id) {
                        onDeleteFolder(id);
                    });
                    return [4 /*yield*/, Promise.all(itemsToDelete.media.map(function (id) { return __awaiter(void 0, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, onDeleteMedia(collectionName, id)];
                                    case 1:
                                        _a.sent();
                                        return [2 /*return*/];
                                }
                            });
                        }); }))];
                case 1:
                    _a.sent();
                    setItemsToDelete({ folders: [], media: [] });
                    toggleConfirmationModal();
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _a.sent();
                    logger.error("Error during deletion:", error_1);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var openDetailsDialog = (0, react_1.useCallback)(function (media, event) {
        setSelectedMediaDetails(media);
        setAnchorEl(event.currentTarget);
        setDetailsDialogOpen(true);
    }, []);
    var closeDetailsDialog = (0, react_1.useCallback)(function () {
        setDetailsDialogOpen(false);
        setSelectedMediaDetails(null);
        setAnchorEl(null);
    }, []);
    var findFolderNameById = function (id) {
        var folder = folders.find(function (folder) { return folder.id === id; });
        return folder ? folder.name : "";
    };
    var handleOpenFolderAccessModal = function (folderId) {
        var folderName = findFolderNameById(folderId);
        openFolderAccessModal(folderId, folderName);
    };
    var _p = (0, react_dnd_1.useDrop)({
        accept: [react_dnd_html5_backend_1.NativeTypes.FILE, "MEDIA", "FOLDER"],
        drop: function (item, monitor) {
            var dropResult = monitor.getDropResult();
            var targetFolderId = dropResult === null || dropResult === void 0 ? void 0 : dropResult.folderId;
            if (!targetFolderId)
                return;
            var itemType = monitor.getItemType();
            var normalizeId = function (item, collection) { return collection.find(function (m) { return m.id === item.id || m.uuid === item.id; }); };
            var draggedMedia = itemType === "MEDIA" && item.id ? [normalizeId(item, media)] : [];
            var draggedFolders = itemType === "FOLDER" && item.id ? [normalizeId(item, folders)].filter(function (f) { return f && f.id !== targetFolderId; }) : [];
            var selectedMedia = (selectedMediaIds && selectedMediaIds.length > 0)
                ? selectedMediaIds.map(function (id) { return normalizeId({ id: id }, media); })
                : draggedMedia;
            var selectedFolders = (selectedFolderIds && selectedFolderIds.length > 0)
                ? selectedFolderIds.map(function (id) { return normalizeId({ id: id }, folders); }).filter(function (f) { return f && f.id !== targetFolderId; })
                : draggedFolders;
            if (selectedMedia.length > 0) {
                handleMoveMultipleMediaToFolder(selectedMedia, targetFolderId);
            }
            if (selectedFolders.length > 0) {
                handleMoveMultipleFoldersToFolder(selectedFolders, targetFolderId);
            }
            unselect(__spreadArray(__spreadArray([], selectedMedia.map(function (media) { return media.uuid; }), true), selectedFolders.map(function (folder) { return folder.id; }), true));
        },
        collect: function (monitor) { return ({
            isOver: monitor.isOver(),
            canDrop: monitor.canDrop(),
        }); },
    }), _q = _p[0], isOver = _q.isOver, canDrop = _q.canDrop, drop = _p[1];
    return (react_1.default.createElement(react_dnd_1.DndProvider, { backend: react_dnd_html5_backend_1.HTML5Backend },
        react_1.default.createElement("div", { ref: drop, style: { opacity: isOver ? 0.8 : 1, backgroundColor: canDrop ? "lightyellow" : "transparent" } },
            react_1.default.createElement(react_admin_1.List, { exporter: false, pagination: false, sx: {
                    "& .RaList-content": {
                        boxShadow: "none",
                        backgroundColor: "white",
                        paddingTop: "30px",
                    },
                    "& .RaList-actions": {
                        backgroundColor: "white",
                    },
                }, empty: react_1.default.createElement(CustomEmpty_1.default, null), queryOptions: {
                    refetchOnWindowFocus: false,
                    refetchOnReconnect: false,
                    refetchOnMount: false,
                    refetchInterval: 1000 * 60,
                } },
                react_1.default.createElement(styles_1.ThemeProvider, { theme: RAStyles_1.RaDatagridTheme },
                    react_1.default.createElement(react_admin_1.Datagrid, { sx: RAStyles_1.RaMediaLibraryDataGridSx, data: filteredItems, rowSx: function (record) {
                            var isDragging = (0, react_dnd_1.useDrag)({
                                type: record.type,
                                item: __assign(__assign({}, record), { id: record.originalId }),
                                collect: function (monitor) { return ({
                                    isDragging: monitor.isDragging(),
                                }); },
                            })[0].isDragging;
                            return {
                                alignItems: "center",
                                opacity: isDragging ? 0.5 : 1,
                                cursor: "move",
                                backgroundColor: selectedIds.includes(record.uuid || record.id) ? "#F5F5F5" : "transparent",
                                borderRadius: "5px",
                            };
                        }, rowClick: function (id, resource, record) {
                            handleRowClick({ detail: 1, record: record });
                            return false;
                        }, bulkActionButtons: react_1.default.createElement(CheckBoxAction, { items: filteredItems, onCheckBoxTick: onCheckBoxTickHandler }), empty: react_1.default.createElement(CustomNoResults_1.default, null) },
                        react_1.default.createElement(ThumbnailWithNameField, { selectedMediaIds: selectedMediaIds, selectedFolderIds: selectedFolderIds, permissions: permissions, handleChangeFolderName: handleChangeFolderName, label: t("Name"), folderPermissions: folderPermissions }),
                        react_1.default.createElement(TypeField, { source: "mime_type", label: t("Type"), sortable: false }),
                        react_1.default.createElement(react_admin_1.TextField, { source: "size", label: t("Size"), sortable: false }),
                        react_1.default.createElement(react_admin_1.DateField, { source: "created_at", label: t("Uploaded at"), sortable: false }),
                        react_1.default.createElement(MeatballMenuField_1.default, { onDownloadMedia: function (mediaId) { return onDownloadMedia([mediaId]); }, onDeleteFolder: function (folderId) { return handleDeleteRequest([folderId], []); }, onDeleteMedia: function (mediaId) { return handleDeleteRequest([], [mediaId]); }, onDetails: function (media, event) { return openDetailsDialog(media, event); }, openFolderAccessModal: handleOpenFolderAccessModal, folderPermissions: folderPermissions }))))),
        react_1.default.createElement(q_play_components_1.ConfirmationModal, { isShown: confirmationModalOpened, onClose: toggleConfirmationModal, onConfirm: handleConfirmDelete, onCancel: toggleConfirmationModal, headerText: t("Confirm"), message: t("Are you sure you want to delete the selected items?"), actionRequired: true, confirmLabel: t("Yes"), cancelLabel: t("Cancel"), centered: true }),
        react_1.default.createElement(MediaPreviewModal_1.default, { isShown: previewModalShown, toggle: togglePreviewModal, url: previewImageUrl !== null && previewImageUrl !== void 0 ? previewImageUrl : "", mediaType: previewMediaType !== null && previewMediaType !== void 0 ? previewMediaType : "" }),
        react_1.default.createElement(MediaDetailsDialog_1.default, { open: detailsDialogOpen, onClose: closeDetailsDialog, media: selectedMediaDetails, anchorEl: anchorEl, viewType: "list" })));
};
exports.default = MediaLibraryListView;
